const baseURL = process.env.REACT_APP_MPOKKET_CONVOZE_BASE_API_URL;

// const apiEndPointsConfig = {
//   addLogin: `${baseURL}/user-login`,
//   register: `${baseURL}/add-user`,
//   upload: `${baseURL}/call-recording/upload`,
//   demoUploadFile: `${baseURL}/call-recording/demo-upload`,
//   audioTable: `${baseURL}/call-recording/get-all`,
//   transcript: `${baseURL}/transcript/call-recording`,
//   dashboard: `${baseURL}/dashboard/insights`,
//   industryType: `${baseURL}/industry-type-list`,
//   demoTranscript: `${baseURL}/audio-insight`,
//   interaction: `${baseURL}/interactions`,
//   interactionList: `${baseURL}/interactions`,
//   qaParameters: `${baseURL}/qa-audit`,
//   agentCampaignList: `${baseURL}/filter-details`,
//   userProfile: `${baseURL}/user-details `,
//   //agent
//   agentMyCalls: `${baseURL}/agent/call-analytics`,
//   agentDashboard: `${baseURL}/agent/dashboard`,
//   agentLeaderboard: `${baseURL}/agent/leaderboard`,
// };

const apiEndPointsConfig = {
  addLogin: `${baseURL}/manager-panel/login`,
  register: `${baseURL}/manager-panel/add-user`,
  upload: `${baseURL}/manager-panel/call-recording/upload`,
  publicUpload: `${baseURL}/manager-panel/call-recording/public-upload`,
  demoUploadFile: `${baseURL}/manager-panel/call-recording/demo-upload`,
  audioTable: `${baseURL}/manager-panel/call-recording/list`,
  transcript: `${baseURL}/manager-panel/transcription/audio-insight`,
  dashboard: `${baseURL}/manager-panel/dashboard/insights`,
  dashboardFilterOptions: `${baseURL}/manager-panel/dashboard/filter-options`,
  interactionTrendAnalytics: `${baseURL}/manager-panel/interactions/last-month-trends`,
  qualitySummary: `${baseURL}/manager-panel/interactions/quality-summary`,
  dashboardRawData: `${baseURL}/manager-panel/interactions/dashboard-raw-data`,
  industryType: `${baseURL}/manager-panel/industry-type/list`,
  demoTranscript: `${baseURL}/audio-insight`,
  interaction: `${baseURL}/manager-panel/interactions/list`,
  interactionList: `${baseURL}/manager-panel/interactions`,
  qaParameters: `${baseURL}/manager-panel/qa-audit`,
  agentCampaignList: `${baseURL}/manager-panel/interactions/filter-details`,
  userProfile: `${baseURL}/manager-panel/profile-details`,
  agentList: `${baseURL}/manager-panel/agent-list`,
  changePassword: `${baseURL}/manager-panel/change-password`,
  billing: `${baseURL}/manager-panel/billing-invoice`,
  agentProfile: `${baseURL}/manager-panel/agent-profile `,
  exportExcelInteraction: `${baseURL}/manager-panel/interactions/excel-interaction`,
  chatbotApi: `${baseURL}/chatbot/chatbot-query`,
  companyList: `${baseURL}/super-admin-panel/companies`,
  ReprocessQaparameter: `${baseURL}/manager-panel/reprocess-qa-audit`,
  ReprocessInteractionInsight: `${baseURL}/manager-panel/reprocess-interaction`,
  updateQaParameters: `${baseURL}/manager-panel/update-qa-parameters`,
  qaParameterManualReview: `${baseURL}/manager-panel/qa-parameter-manual-review`,
  qaOverallRemarks: `${baseURL}/manager-panel/qa-overall-remarks`,
  manualQaAudit: `${baseURL}/manager-panel/manual-qa-audit`,
  updateMultipleQaParameters: `${baseURL}/manager-panel/update-multiple-qa-parameters`,
  qaEntities: `${baseURL}/manager-panel/qa-entities`,
  customerDocumentLog: `${baseURL}/manager-panel/customer-document-log`,

  // pipeline status (public dashboard) — day-wise transcription/interaction/curated counts
  // and live extraction backlog
  transcriptionExtractedCount: `${baseURL}/manager-panel/interactions/transcription-count`,
  interactionExtractedCount: `${baseURL}/manager-panel/interactions/extracted-count`,
  curatedProcessedCount: `${baseURL}/manager-panel/interactions/processed-count`,
  pendingExtractionCount: `${baseURL}/manager-panel/interactions/pending-extraction-count`,
  dayWiseAht: `${baseURL}/manager-panel/interactions/day-wise-aht`,



  // super admin 
  defaultListOfQAparameter: `${baseURL}/convoze-default-prompt`,
  invoiceGeneration: `${baseURL}/super-admin/billing-invoice`,
  downloadInvoice: `${baseURL}/super-admin/download-invoice`,
  clientOnboarding: `${baseURL}/super-admin-panel/client-management`,
  clientList: `${baseURL}/super-admin-panel/client-list`,
  updateCompanyData: `${baseURL}/super-admin-panel/update-client-data`,
  clinetPromptData: `${baseURL}/super-admin-panel/client-prompt-data`,
  updateClientPrompt: `${baseURL}/super-admin-panel/update-client-prompt`,
  processList: `${baseURL}/super-admin-panel/process-list`,
  processPromptData: `${baseURL}/super-admin-panel/process-prompt-data`,
  qaParameterMaster: `${baseURL}/super-admin-panel/qa-parameter`,
  qaParameterTaxonomy: `${baseURL}/super-admin-panel/qa-parameter-taxonomy`,
  qaParameterTaxonomyJson: `${baseURL}/super-admin-panel/qa-parameter-taxonomy/json`,
  qaGlobalRules: `${baseURL}/super-admin-panel/qa-global-rules`,
  cronJobList: `${baseURL}/super-admin-panel/cron-job-list`,
  updateCronJob: `${baseURL}/super-admin-panel/update-cron-job`,
  keywordAlertSettings: `${baseURL}/super-admin-panel/keyword-alert/settings`,
  keywordAlertList: `${baseURL}/super-admin-panel/keyword-alert/list`,
  keywordAlertKeywords: `${baseURL}/super-admin-panel/keyword-alert/keywords`,
  keywordAlertPreview: `${baseURL}/super-admin-panel/keyword-alert/preview`,
  keywordAlertRun: `${baseURL}/super-admin-panel/keyword-alert/run`,
  keywordAlertProgress: `${baseURL}/super-admin-panel/keyword-alert/progress`,
  agentCallEmailSettings: `${baseURL}/super-admin-panel/agent-call-email/settings`,
  agentCallEmailPreview: `${baseURL}/super-admin-panel/agent-call-email/preview`,
  agentCallEmailRun: `${baseURL}/super-admin-panel/agent-call-email/run`,
  agentCallEmailProgress: `${baseURL}/super-admin-panel/agent-call-email/progress`,
  agentCallEmailHistory: `${baseURL}/super-admin-panel/agent-call-email/history`,
  sttCredentialList: `${baseURL}/super-admin-panel/stt-credential-list`,
  sttCredential: `${baseURL}/super-admin-panel/stt-credential`, // POST here, PATCH/DELETE at + /:sttModel
  llmCredentialList: `${baseURL}/super-admin-panel/llm-credential-list`,
  llmCredential: `${baseURL}/super-admin-panel/llm-credential`, // POST here, PATCH/DELETE at + /:providerKey
  openRouterQaList: `${baseURL}/super-admin-panel/openrouter-qa/list`,
  openRouterQa: `${baseURL}/super-admin-panel/openrouter-qa`, // GET + /:id
  openRouterQaProcess: `${baseURL}/super-admin-panel/openrouter-qa/process`,
  aiEngineList: `${baseURL}/super-admin-panel/ai-engine-list`, // GET ?companyId=...
  aiEngine: `${baseURL}/super-admin-panel/ai-engine`, // POST here, PATCH/DELETE at + /:engineId
  aiEngineModeList: `${baseURL}/super-admin-panel/ai-engine-mode-list`, // GET ?mode=apis1|apis2|apis3
  aiEngineMode: `${baseURL}/super-admin-panel/ai-engine-mode`, // POST here, PATCH/DELETE at + /:engineId
  aiEngineModeStatus: `${baseURL}/super-admin-panel/ai-engine-mode-status`, // GET both servers' processing on/off, PATCH { mode, processingEnabled }
  aiEngineModeOperations: `${baseURL}/super-admin-panel/ai-engine-mode-operations`, // PATCH { mode, operations?: { op: bool }, concurrencyLimits?: { op: number|null } }
  processingClusterStatus: `${baseURL}/super-admin-panel/processing/cluster-status`, // GET ?stage=<key> for in-flight leases + dead letters
  processingRequeue: `${baseURL}/super-admin-panel/processing/requeue`, // POST { stage, recordIds? | all: true }
  processingConfigAudit: `${baseURL}/super-admin-panel/processing/config-audit`, // GET ?mode=&limit=



  //agent
  agentMyCalls: `${baseURL}/agent-panel/call-analytics`,
  agentDashboard: `${baseURL}/agent-panel/dashboard/insights`,
  agentLeaderboard: `${baseURL}/agent-panel/leaderboard`,
  agentKpis: `${baseURL}/agent-panel/kpis-analytics`,
  agentAuditResponse: `${baseURL}/agent-panel/audit-response`, // GET/POST + /:id (encrypted transcriptionId)


  //user management 
  createUser: `${baseURL}/manager-panel/users-add`,
  updateUser: `${baseURL}/manager-panel/update-user`,
  assignUserRole: `${baseURL}/manager-panel/user-management/assign-role`,
  importUsersPreview: `${baseURL}/manager-panel/user-management/import/preview`,
  importUsers: `${baseURL}/manager-panel/user-management/import`,
  getUsers: `${baseURL}/manager-panel/user-management`,
  deleteUser: `${baseURL}/manager-panel/delete-user`,
  nextEmployeeId: `${baseURL}/manager-panel/next-employee-id`,
  assignableAgents: `${baseURL}/manager-panel/user-management/assignable-agents`,
  userDetailForEdit: `${baseURL}/manager-panel/user-management`, // + /:employeeId/detail
  rolePermissions: `${baseURL}/manager-panel/role-permissions`,
  roleDataScopeSummary: `${baseURL}/manager-panel/role-permissions/data-scope`,
  myPermissions: `${baseURL}/manager-panel/permissions/me`,
  impersonateUser: `${baseURL}/manager-panel/user-management`, // + /:employeeId/impersonate
  endImpersonation: `${baseURL}/manager-panel/end-impersonation`,
  assignmentSupervisors: `${baseURL}/manager-panel/agent-assignment/supervisors`,
  assignmentAgents: `${baseURL}/manager-panel/agent-assignment/agents`,
  manualAuditFields: `${baseURL}/manager-panel/manual-audit-fields`,
  manualAudits: `${baseURL}/manager-panel/manual-audits`,
  manualAuditDrafts: `${baseURL}/manager-panel/manual-audit-drafts`,
  manualAuditOptions: `${baseURL}/manager-panel/manual-audit-options`, // + /:listKey(/:id) for admin edits
  manualAuditAoaVariance: `${baseURL}/manager-panel/manual-audit-dashboard/aoa-variance`,
  knowledgePortalSheets: `${baseURL}/manager-panel/knowledge-portal/sheets`, // + /:id
  knowledgePortalSearch: `${baseURL}/manager-panel/knowledge-portal/search`,
  sensitiveKeywordAlerts: `${baseURL}/manager-panel/sensitive-keyword-alerts`,
  feedbackAcceptance: `${baseURL}/manager-panel/feedback-acceptance`, // + /summary, /calls, /export
  goodCallLibraryCalls: `${baseURL}/manager-panel/good-call-library/calls`, // + /:id, /:id/recording, /:id/listen, /:id/listeners
  goodCallLibraryLookup: `${baseURL}/manager-panel/good-call-library/lookup`,
  assignmentAssign: `${baseURL}/manager-panel/agent-assignment/assign`,
  assignmentUnassign: `${baseURL}/manager-panel/agent-assignment/unassign`,
  assignmentSettings: `${baseURL}/manager-panel/agent-assignment/settings`,
  uploadSop: `${baseURL}/sop-training/upload`,
  hrList: `${baseURL}/manager-panel/hr-list`,
  candidateDetail: `${baseURL}/manager-panel/candidate-detail`,
  reTranscribe: `${baseURL}/manager-panel/transcription/re-transcribe`,
  reTranscribeStatus: `${baseURL}/manager-panel/transcription/re-transcribe/status`,
  toggleCuration: `${baseURL}/manager-panel/interactions/toggle-curation`,
  curatorCallAnalysisImport: `${baseURL}/curator/call-analysis/import-excel`,

  // SuperAdmin-only Update Tracker (create/edit/approve tickets)
  trackerList: `${baseURL}/super-admin-panel/tracker`, // GET list, POST create
  trackerDetail: `${baseURL}/super-admin-panel/tracker`, // + /:id for GET/PUT/DELETE
  trackerApprove: `${baseURL}/super-admin-panel/tracker`, // + /:id/approve for PUT
  trackerApprovers: `${baseURL}/super-admin-panel/tracker/approvers`, // GET list of SuperAdmin users
  trackerMyApprovals: `${baseURL}/super-admin-panel/tracker/my-approvals`, // GET tickets pending my approval
  trackerHistory: `${baseURL}/super-admin-panel/tracker`, // + /:id/history for GET
  // trackerSyncSheet: `${baseURL}/super-admin-panel/tracker/sync-sheet`, // POST pull tickets from Google Sheet

  // Activity Log (audit trail) — read-only; Admin (own company) and SuperAdmin (all companies)
  activityLogs: `${baseURL}/manager-panel/activity-logs`, // GET list, + /:logId for detail
  activityLogFilterOptions: `${baseURL}/manager-panel/activity-logs/filter-options`,
  logout: `${baseURL}/manager-panel/logout`, // POST — records the LOGOUT activity before the client clears its session
};

export default apiEndPointsConfig;
